(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		define('stagingService', ['cookie-utils', 'statusService', 'repositoryService', 'storeService'], function (cookieUtils, userService, repositoryService, storeService) {
			return factory(root, cookieUtils, userService, repositoryService, storeService);
		});
	} else {
		root.stagingService = factory(root, cookieUtils, userService, repositoryService, storeService);
	}
})(this, function (root, cookieUtils, userService, repositoryService, storeService) {

	/* JSON Keys for THD_LOCALIZER */

	var WORKFLOW = 'WORKFLOW';
	var THD_INTERNAL = 'THD_INTERNAL';
	var THD_FORCE_LOC = 'THD_FORCE_LOC';
	var THD_STRFINDERZIP = 'THD_STRFINDERZIP';
	var THD_LOCSTORE = 'THD_LOCSTORE';
	var THD_STORE_HOURS = 'THD_STORE_HOURS';
	var THD_STORE_HOURS_EXPIRY = 'THD_STORE_HOURS_EXPIRY';

	/**
	 * @constant
	 * @type {Array}
	 */
	var INTERNAL_USERS = ['KNOWN_LOCATION', 'THD_STORE_LOCATION', 'DEFAULT_INTERNAL'];

	/**
	 * @constant
	 * @type {Array}
	 */
	var EXTERNAL_USERS = ['LOC_HISTORY_BY_IP', 'LOC_HISTORY_BY_SUBNET', 'GEO_LOCATION', 'DEFAULT'];

	var workflowMapper = userService.workflowMapper;
	var THD_LOCALIZER = {};
	var oneHour = 60 * 60 * 1000; // an hour in milliseconds

	/**
	 * @module StagingService
	 * @description Set THD_LOCALIZER in json format.
	 * @type {Object}
	 */
	var stagingService = {
		__setTHDLocalizer: function __setTHDLocalizer(localStore, workflow, copyFromTHDPersist) {
			try {
				/*
				 *	Set WORKFLOW and THD_FORCE_LOC
				 */
				THD_LOCALIZER[WORKFLOW] = workflow;
				THD_LOCALIZER[THD_FORCE_LOC] = workflowMapper[workflow].category;

				/*
				 *	Set THD_INTERNAL
				 */

				if (INTERNAL_USERS.indexOf(workflow) !== -1 || repositoryService.getValue(THD_INTERNAL) === '1') {
					THD_LOCALIZER[THD_INTERNAL] = '1';
				} else if (EXTERNAL_USERS.indexOf(workflow) !== -1 || repositoryService.getValue(THD_INTERNAL) === '0') {
					THD_LOCALIZER[THD_INTERNAL] = '0';
				}

				/*
				 * 	Set THD_LOCSTORE and THD_STRFINDERZIP
				 */

				var fixedStoreId = localStore.storeId.replace(/^0/, '');
				var storeDetails;

				/*
				 *  Copy from PERSIST if already Localized
				 */

				if (copyFromTHDPersist) {
					storeDetails = fixedStoreId + '+' + localStore.name + ' - ' + localStore.city + ', ' + localStore.state + '+';
					THD_LOCALIZER[THD_STRFINDERZIP] = localStore.zipcode;
				} else {
					storeDetails = fixedStoreId + '+' + localStore.name + ' - ' + localStore.address.city + ', ' + localStore.address.state + '+';
					THD_LOCALIZER[THD_STRFINDERZIP] = localStore.address.postalCode;
				}
				THD_LOCALIZER[THD_LOCSTORE] = storeDetails;
				
				/*
				 *	Set Store Hours for THD Localizer
				 */
				THD_LOCALIZER[THD_STORE_HOURS] = storeService.mapStoreHoursToString(localStore.storeHours);
				THD_LOCALIZER[THD_STORE_HOURS_EXPIRY] = this.__calculateExpiryTime(oneHour);

				repositoryService.setToCookie(THD_LOCALIZER);

			} catch (e) {
				console.error("Error setting THD_LOCALIZER " + e);
			}
		},

		/**
		 * @module StagingService
		 * @description Get THD_LOCALIZER in json format.
		 * @type {Object}
		 */

		__getTHDLocalizer: function __getTHDLocalizer() {
			var thdLocalizer = cookieUtils.readCookie('THD_LOCALIZER');
			try {
				var decodedString = decodeURIComponent(thdLocalizer);
				return decodedString && JSON.parse(decodedString);
			} catch (e) {
				console.error("Error in parsing THD_LOCALIZER " + e);
				return;
			}
		},

		__getExistingLocalizer: function __getExistingLocalizer() {
			var oldLocalizer = {};
			try {
				oldLocalizer.O_WORKFLOW = userService.status.getWorkflow();
				oldLocalizer.O_THD_FORCE_LOC = repositoryService.get(THD_FORCE_LOC, userService.status.getWorkflow());
				oldLocalizer.O_THD_INTERNAL = repositoryService.get(THD_INTERNAL, userService.status.getWorkflow());
				oldLocalizer.O_THD_STRFINDERZIP = repositoryService.get(THD_STRFINDERZIP);
				oldLocalizer.O_THD_LOCSTORE = repositoryService.get(THD_LOCSTORE, userService.status.getWorkflow());
			} catch (e) {
				console.error("Error copying existing localizer to THD_LOCALIZER " + e);
			}

			return oldLocalizer;
		},

		__calculateExpiryTime: function __calculateExpiryTime(expiryTimeInMs) {
			var expiryDate = new Date();
			try {
				expiryDate.setTime(expiryDate.getTime() + expiryTimeInMs);
				return parseInt(expiryDate.getTime() / 1000);
			}catch (e) {
				console.error("Error calculating expiry time " + e);
			}
		},
		
		__setStoreHours: function __setStoreHours(response) {
			try {
				if(response.storeHours) {
					var storeHours = storeService.mapStoreHoursToString(response.storeHours);
					var storeHoursExpiry = this.__calculateExpiryTime(oneHour);
					repositoryService.setValue('THD_STORE_HOURS', storeHours);
					repositoryService.setValue('THD_STORE_HOURS_EXPIRY', storeHoursExpiry);
				}
			} catch(e) {
				console.error("Error in setting store hours expiry time " + e);
			}
		}
	}

	return stagingService;
});


//////////////////
// WEBPACK FOOTER
// ./src/stagingService.js
// module id = 9
// module chunks = 0